module.exports = __webpack_public_path__ + "img/speaker-right-bg.58041fc7.png";